import { Link } from "react-router-dom";
import logo from "/logo.jpg";

function Logo() {
  return (
    <Link className="flex items-center justify-center p-4" to={"/"}>
      <img src={logo} alt="logo" className="h-16 w-16 object-contain" />
      <span className="ml-4 text-xl font-bold text-primary-100">PrimeChart</span>
    </Link>
  );
}

export default Logo;
